// put sychronous functions for changing state e.g. add, edit, delete
export default {
  'SET_USER' (state, payload) {
    state.user = payload.user
  },
  'CLEAR_USER' (state) {
    state.user = {}
  },
  'SET_USERNAME' (state, payload) {
    state.username = payload.username
  },
  'CLEAR_USERNAME' (state) {
    state.username = null
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js